// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_a7g","cls2":"ArticlesFilters-cls2_zXL ArticlesFilters-cls1_a7g"};